import React from "react";

export default function LightningBackdrop() {
  return (
    <div className="ambient-field absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="ambient-field__texture" />
      <div className="ambient-field__section-glow ambient-field__section-glow--hero" />
      <div className="ambient-field__section-glow ambient-field__section-glow--games" />
      <div className="ambient-field__section-glow ambient-field__section-glow--contact" />
      <div className="ambient-field__vignette" />
    </div>
  );
}
